export const SKYKICKPRODUCTS = [
    { active: false, name: "Backup Full", value: 5, source: 5, destination: null, partnerId: null, mappingDate: null, productMappingId: null, mappingError: null }, 
    { active: false, name: "Backup Exchange", value: 10, source: 10, destination: null, partnerId: null, mappingDate: null, productMappingId: null, mappingError: null }, 
    { active: false, name: "Backup SharePoint/OneDrive", value: 15, source: 15, destination: null, partnerId: null, mappingDate: null, productMappingId: null, mappingError: null }
]
